import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './store';
import App from './App';
import axios from 'axios';
import { HashRouter } from 'react-router-dom';
import * as helpers from './utils'
import config from './config';
import * as serviceWorker from './serviceWorker';
import { toast } from 'react-toastify';

axios.interceptors.request.use((request) => {
    console.log(navigator.onLine);
    if (navigator.onLine === false) {
        toast.error('No Internet Connection')
        return
    }
    if (!localStorage.getItem("ACCESS_TOKEN") || request.url.includes('account/forget_password/') || request.url.includes('account/update_password/')) {
        if (axios.defaults.headers.common["Authorization"])
            delete axios.defaults.headers.common["Authorization"];
        return request;
    }

    request.headers = setHeaders()

    return request
})




axios.interceptors.response.use(
    (response) => {
        return response
    }, (error) => {
        const originalRequest = error.config;

        if (error.response && error.response.status === 401 && originalRequest.url.includes('token/refresh/')) {
            helpers.clear()
            return Promise.reject(error);
        }
        if (error.response && error.response.data.code === 'user_inactive') {
            localStorage.clear();
            sessionStorage.clear()
            
            window.location.reload();
            toast.error(error.response.data.code)
        }
        if (error.response && error.response.status === 401 && !originalRequest._retry && localStorage.getItem("ACCESS_TOKEN")) {
            originalRequest._retry = true;
            const baseUrl = config.apiGateway.URL + config.apiGateway.VERSION
            return axios.post(baseUrl + 'token/refresh/', {
                "refresh": localStorage.getItem('REFRESH_TOKEN')
            })
                .then(res => {
                    if (res.status === 200) {
                        localStorage.setItem("ACCESS_TOKEN", res.data.access)
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('ACCESS_TOKEN');
                        return axios(originalRequest);
                    }

                })
        }

        return Promise.reject(error);
    }
)

const setHeaders = () => {
    if (localStorage.getItem("ACCESS_TOKEN")) {
        return {
            'Authorization': `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
            'Content-Type': 'application/json'
        }
    }
    return {
        'Content-Type': 'application/json'
    }
}

const store = configureStore();



ReactDOM.render(<
    React.StrictMode >
    <Provider store={store} >
        <HashRouter>
            <App />
        </HashRouter>

    </Provider>
</React.StrictMode >, document.getElementById('root')
);

serviceWorker.unregister();